import { useState, useEffect, FormEvent } from 'react';
import { useRouter } from 'next/router';
import Avatar from 'avataaars';
import { getRandomOptions } from 'utils/avatarOptions';
import Layout from 'components/Layout';
import BottomBar from 'components/BottomBar';
import {
  getNameFromLocalStorage,
  getAvatarFromLocalStorage,
  saveNameToLocalStorage,
  saveAvatarToLocalStorage,
  getLocalOrganization,
  clearLocalOrganization,
} from 'utils/userDetails';
import { Organization } from 'interfaces';

const Settings = () => {
  const [name, setName] = useState<string | null>(null);
  const [avatarOptions, setAvatarOptions] = useState(getRandomOptions(false));
  const [org, setOrg] = useState<Organization>();
  const router = useRouter();

  useEffect(() => {
    setName(getNameFromLocalStorage());
    const avatar = getAvatarFromLocalStorage();
    if (avatar) {
      setAvatarOptions(avatar);
    }

    let o = getLocalOrganization();
    if (o) {
      setOrg(o);
    }
  }, []);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();

    if (name !== null) {
      saveNameToLocalStorage(name);
      saveAvatarToLocalStorage(avatarOptions);

      const { redirectTo } = router.query;
      if (redirectTo) {
        router.push({ pathname: redirectTo as string });
      } else {
        router.back();
      }
    }
  }

  async function handleBillingClick() {
    if (!org) {
      return;
    }
    router.push(`/lounge/${org.slug}/billing`);
  }

  function logout() {
    clearLocalOrganization();
    setOrg(undefined);
    router.push('/lounge/new');
  }

  return (
    <Layout title="Settings">
      {org ? (
        <div>
          <h2 className="text-2xl font-bold">Organization</h2>
          <p>
            You are part of the organization{' '}
            <span className="text-indigo-600 font-bold">{org.name}</span>.
          </p>

          <div className="mt-4 flex justify-between flex-wrap">
            <button className="btn btn-indigo" onClick={handleBillingClick}>
              Manage Billing
            </button>
            <button className="btn btn-indigo-secondary" onClick={logout}>
              Log out of {org.name}
            </button>
          </div>

          <hr className="mt-6 mb-3" />
        </div>
      ) : (
        ''
      )}

      <h2 className="text-2xl font-bold">Avatar</h2>

      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="rounded-md shadow-sm">
          <div>
            <label
              className="block text-sm leading-5 font-medium text-gray-700"
              htmlFor="name"
            >
              Your name
            </label>
            <input
              aria-label="Name"
              id="name"
              name="name"
              type="text"
              required
              className="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
              placeholder="John Doe"
              value={name ? name : ''}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>

        <BottomBar>
          <div className="flex justify-center">
            <button
              className="btn btn-indigo w-full max-w-lg text-xl"
              type="submit"
            >
              Save
            </button>
          </div>
        </BottomBar>
      </form>

      <label className="block mt-2 text-sm leading-5 font-medium text-gray-700">
        Your avatar
      </label>

      <div className="mt-2 flex justify-center">
        <div className="flex justify-between w-screen max-w-lg">
          <button
            className="btn btn-indigo-secondary w-full mr-2"
            onClick={() => setAvatarOptions(getRandomOptions(true))}
          >
            Random Man 👨
          </button>

          <button
            className="btn btn-indigo-secondary w-full mr-2"
            onClick={() => setAvatarOptions(getRandomOptions(false))}
          >
            Random Woman 👩
          </button>
        </div>
      </div>
      <div className="flex justify-center">
        <div className="w-56">
          <Avatar {...avatarOptions} />
        </div>
      </div>
    </Layout>
  );
};

export default Settings;
